﻿import { ApiService } from "@app/services/api.service";
import { Token } from "@app/di/token";
import { NgService } from "@app/di/decorators";
import { Utils } from "@tools";

@NgService({
    token: Token.InteractionService,
    dependencies: [
        Token.ApiService
    ]
})
export class InteractionService {
    constructor(private api: ApiService) {

    }

    public record(idConfigurator: number): ng.IPromise<any> {
        let guid = null;
        try {
            guid = window.localStorage["userGuid"];
            if (!guid) {
                guid = window.localStorage["userGuid"] = Utils.shortId();
            }
        }
        catch (e) {
            guid = Utils.shortId();
        }

        return this.api.interactions.insert({
            idConfigurator: idConfigurator,
            userGuid: guid
        });
    }
}
